export const openLink = (url: string) => {
  if (typeof window === 'undefined') return;

  if (url.startsWith('http')) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    window.location.href = url;
  }
};
